import React from 'react';

import { SVGPropsType } from 'src/types';

function Operations(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M11.6667 1.66675H5.00004C4.08337 1.66675 3.33337 2.41675 3.33337 3.33341V16.6667C3.33337 17.5834 4.08337 18.3334 5.00004 18.3334H15C15.9167 18.3334 16.6667 17.5834 16.6667 16.6667V6.66675L11.6667 1.66675Z"
                stroke={stroke}
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6666 1.66675V6.66675H16.6666"
                stroke={stroke}
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3333 10.8333H6.66663"
                stroke={stroke}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.3333 14.1667H6.66663"
                stroke={stroke}
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default Operations;
